export default {
  queryTicketUserRecords: '/gateway/cs/ticket/queryTicketUserRecords',
  cancelComplaint: '/gateway/cs/ticket/cancelComplaint',
  urgeTicket: '/gateway/cs/ticket/urgeTicket'
}
